import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import WhatsappLink from '../../components/contact/WhatsappLink';
import { uiHelpers } from '../../helpers';
import { getStripePriceId } from '../../helpers/price.helper';
import {
  SandboxBanner,
  useSandboxPayment,
} from '../../hooks/useSandboxPayment';
import PaymentSelection, { MonthOptions } from './PaymentSelection';
import StripeCheckoutButton from './StripeCheckoutButton';

const H2WithVerticalMargin = styled.h2`
  margin: 5rem 0;
`;

interface Props {
  expireAt: number;
}

const SwitchToStripeSubscriptionView: React.FC<Props> = ({ expireAt }) => {
  const { t } = useTranslation();
  const [month, setMonth] = useState<MonthOptions>(6);
  const [checkingOut, setCheckingOut] = useState(false);
  const usingSandboxPayment = useSandboxPayment();

  const priceId = getStripePriceId(null, month, usingSandboxPayment);

  if (checkingOut) {
    return (
      <Container>
        <Row>
          <Col className="text-center">
            <H2WithVerticalMargin>
              {t('setting-up-subscription')}
            </H2WithVerticalMargin>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      <Row>
        <Col md={6}>
          <p>
            <Trans
              i18nKey="manual-summary"
              values={{
                nextBillTime: uiHelpers.formatDateLocalFromTimestamp(expireAt),
              }}
              components={{ bold: <b /> }}
            />
          </p>
          <p>
            <Trans
              i18nKey="subscription-switch-summary"
              values={{
                nextBillTime: uiHelpers.formatDateLocalFromTimestamp(expireAt),
                remainingDays: Math.ceil(
                  (expireAt - Date.now() / 1000) / 3600 / 24
                ),
              }}
              components={{ bold: <b /> }}
            />
          </p>
          <p>
            <Trans
              i18nKey="whatsapp-us-if-you-have-any-questions"
              components={{ link: <WhatsappLink /> }}
            />
          </p>
        </Col>
        <Col md={6}>
          <PaymentSelection
            freeTrialAvailable={false}
            month={month}
            setMonth={setMonth}
            disablePromo
          />
        </Col>
      </Row>
      <Row>
        <Col>
          {usingSandboxPayment && <SandboxBanner />}
          <br />
          <StripeCheckoutButton
            isSandbox={usingSandboxPayment}
            priceId={priceId}
            onCompleted={() => setCheckingOut(true)}
            switchFromManual
            metadata={{
              month: month.toString(),
              priceId,
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default SwitchToStripeSubscriptionView;
